import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './SpeakingHints.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import addCirclePng from'../asset/add-circle.png';
import {Image} from 'react-bootstrap';
import musicPlayer from'../asset/music-player.png';

export default function SpeakingHints(prop) {	
	const navigate = useNavigate();
	
	let itemId = prop.itemId;
	
	const [topic, setTopic] = useState("");
	const [topicHk, setTopicHk] = useState("");
	const [coreMsg, setCoreMsg] = useState("");
	const [coreMsgHk, setCoreMsgHk] = useState("");
	const [coreMsgAudioPath, setCoreMsgAudioPath] = useState();
	
	const [aMsgDetail, setAMsgDetail] = useState([]);
	const [bMsgDetail, setBMsgDetail] = useState([]);
	
	
	const convertSrt = async () => {
		let obj = {
			'itemId' : itemId,
		}
		await postData("item/processSpeakingHkSrt", obj, navigate); 
		fetchData();
	}
	
	const generalItemUpload = async (selectedFile) => {
		
		try {			
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("generalfile", selectedFile);
			
      let res = await postFormData("utility/generalItemUpload", data, navigate);
			return res.data;
    } catch (err) {
			return null;
      console.log(err);
    }
		
	}
	
	
	const SoundPlayer = ({soundFile}) => {
    var savingCurrencySound = soundFile;
    var playCurrencySound = () => {     
        var audio = new Audio(savingCurrencySound);
        audio.play();
    }
    return (
			<Image className={s.music_player} fluid onClick={ () => playCurrencySound() }
				src={musicPlayer} rounded />
		
    );
	}
	
	
	
	const fetchData = async () => {
		getData('item/getSpeakingHintsByItemId?itemId=' + itemId, navigate)
		.then(res => {
				setTopic(res.data.topic);
				setCoreMsg(res.data.coreMsg);
				setTopicHk(res.data.coreMsgJson.topic_hk);
				setCoreMsgHk(res.data.coreMsgJson.hk);
				
				setAMsgDetail(res.data.aMsgDetail);
				setBMsgDetail(res.data.bMsgDetail);
			}
		);
	}
	
	const quickCreateHints = async () => {
		const sections = sentence.split(/\n\s*\n/);
		
		let topic = sections[0]
		let main = sections[1];
		let partA = sections[2].trim().split('\n');
		let partB = sections[3].trim().split('\n');
		
		setTopic(topic);
		setCoreMsg(main);
		let partAArray = [];
		for (const p of partA) {
			partAArray.push({type:"a",msg:p,msgJson:{hk:""}, soundTrack:null});
		}
		setAMsgDetail(partAArray);
		
		
		let partBArray = [];
		for (const p of partB) {
			partBArray.push({type:"b",msg:p,msgJson:{hk:""}, soundTrack:null});
		}
		setBMsgDetail(partBArray);
	}
	
	
	const updateSpeakingHints = async () => {
		let obj = {
			itemId,
			topic,
			coreMsg,
			coreMsgAudioPath,
			aMsgDetail,
			bMsgDetail
		}
		
		await postData("item/updateKeySpeakingMsg", obj, navigate).then(res => {
				setCoreMsg(res.data.coreMsg);
				
				setAMsgDetail(res.data.aMsgDetail);
				setBMsgDetail(res.data.bMsgDetail);
			}
		);
		
	}
	
	
	let tmpString = "topic\n\nmain message\n\npart A\n1.\n2.\n\npart B\n1.\n2.";
	
	const [sentence, setSentence] = useState(tmpString);

	function checkAllHaveId() {
		for (const p of aMsgDetail) {
			if (!p.ordering) {
				return false;
			}
		}
		for (const p of bMsgDetail) {
			if (!p.ordering) {
				return false;
			}
		}
		return true;
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	return (<div style={{textAlign:"left", marginLeft:"20px"}}>
		
			<div>
				<GreenButton isEnabled={true} clickedAction={()=>updateSpeakingHints()} bText={"update"} />
			</div>
			{
				
				(checkAllHaveId())  &&  (<div style={{margin:"5px 0 5px 0"}}>
					<GreenButton isEnabled={true} clickedAction={()=>convertSrt()} bText={"Convert Srt into HK"} />
				</div> )
			}
		
		
				
				{
					
					(aMsgDetail.length == 0 && bMsgDetail.length == 0 && coreMsg =='') && (
					<div style={{background:"#22222222", margin:"10px 10px 10px 0",padding:"10px"}}>
					<div style={{display:"flex",flexDirection:"column"}}>
						<div>Quick Create Detail</div>
						<div><textarea className={s.textAreaAuto} value={sentence} rows={10} wrap='off' onChange={(e) => {
							setSentence(e.target.value);
						}}/>
						</div>
						<div>
						<RedButton isEnabled={true} clickedAction={()=>quickCreateHints()} bText={"Quick Create"} />
						</div>
					</div>
				</div>)
				}
		
		
		
		
		
		
		{
			(!(aMsgDetail.length == 0 && bMsgDetail.length == 0 && coreMsg =='')) &&(<div>
			
			<div>Topic</div>
			<div style={{display:"flex",flexDirection:"column"}}>
				<textarea className={s.processWordTextAreaAuto} style={{width:"80%"}} value={topic} rows={5} onChange={(e) => { 
						setTopic(e.target.value);
					}}
					placeholder="Topics"
				/>
			</div>
			<div>{topicHk}</div>
			
			
			<div>(A) Group Discussion Section</div>
			<div style={{display:"flex",flexDirection:"column"}}>
				<textarea className={s.processWordTextAreaAuto} style={{width:"80%"}} value={coreMsg} rows={5} onChange={(e) => { 
						setCoreMsg(e.target.value);
					}}
					placeholder="Your Computer Science teacher is conducting a session on AI. Your group has been asked to discuss the advantages and disadvantages of artificial intelligence. You may want to discuss:"
				/>
			</div>
			<div>{coreMsgHk}</div>
			<div style={{display:"flex",flexDirection:"row"}}>
				<label htmlFor="file-upload" className={s.custom_file_upload}>
					<input id="file-upload" type="file" style={{display:"none"}} onChange={
						async (e) => {
							let path = await generalItemUpload(e.target.files[0]);
							if (path) {
								setCoreMsgAudioPath(path);
							}
						}} />
					Upload audio
				</label>
				{(coreMsgAudioPath) && (<div style={{marginLeft:"10px"}}><SoundPlayer soundFile={"http://ehla-media-bucket.s3.amazonaws.com/" + coreMsgAudioPath}/></div>)}
			</div>
			
			
			
			
			
			
			<div style={{marginTop:"10px"}}>Detail</div>
				
			<div>
				{
					aMsgDetail.map((a, indexA) => (<div index={indexA} >
						
						<div style={{border:"1px solid #22222222",width:"80%",padding:"0 10px", display:"flex", margin:"5px 0", alignItems:"center"}}>
							<div style={{position:"relative",width:"100%",display:"flex", alignItems:"center"}}>
								{(a.softDeleted) && (<div className={s.overlay}></div>)}
								
								<div style={{display:"flex",flexDirection:"row",margin:"10px",whiteSpace:"nowrap"}}>
									<label htmlFor={"a-"+indexA} className={s.custom_file_upload}>
										<input id={"a-"+indexA} type="file" style={{display:"none"}} onChange={
											async (e) => {
												let path = await generalItemUpload(e.target.files[0]);
												
												if (path) {
													aMsgDetail[indexA].soundTrack = path;
													setAMsgDetail([...aMsgDetail]);
												}
											}} />
										Upload audio
									</label>
									
								</div>
								{(a.soundTrack) && (<SoundPlayer style={{marginRight:"10px"}} soundFile={"http://ehla-media-bucket.s3.amazonaws.com/" + a.soundTrack}/>)}
								{(!a.soundTrack) && (<div style={{width:"35px"}}></div>)}
								<div style={{ width:"100%", margin:"0 10px"}}>
									
									<input className={s.srtWord} type="text" value={a.msg} onChange={(e)=>{
										aMsgDetail[indexA].msg = e.target.value;
										setAMsgDetail([...aMsgDetail]);
									}}/>
									
								<div>{a.msgJson.hk}</div>
								</div>
								
							</div>
							
							<div style={{margin:"0 5px"}} >
								<RedButton isEnabled={true} clickedAction={()=>{
									if (a.softDeleted) {
										delete aMsgDetail[indexA].softDeleted;
									} else {
										aMsgDetail[indexA].softDeleted = true;
									}
									setAMsgDetail([...aMsgDetail]);
								}} bText={"delete"} />
							</div>
							
						</div>
					</div>))
				}
				
				<div className={s.addWordHolder} >
					<img className={s.srtIcon} src={addCirclePng}  onClick={()=>{
						setAMsgDetail([...aMsgDetail, {type:"a",msg:"",msgJson:{hk:""}, soundTrack:null}]);
					}} />
				</div>
				
			</div>
			
			<div>(B) Individual Response:</div>

			<div>
				{
					bMsgDetail.map((b, indexB) => (<div index={indexB} >
						
						<div style={{border:"1px solid #22222222",width:"80%",padding:"0 10px", display:"flex", margin:"5px 0", alignItems:"center"}}>
						
							
							<div style={{display:"flex",flexDirection:"row",margin:"10px",whiteSpace:"nowrap"}}>
								<label htmlFor={"b-"+indexB} className={s.custom_file_upload}>
									<input id={"b-"+indexB} type="file" style={{display:"none"}} onChange={
										async (e) => {
											let path = await generalItemUpload(e.target.files[0]);
											
											if (path) {
												bMsgDetail[indexB].soundTrack = path;
												setBMsgDetail([...bMsgDetail]);
											}
										}} />
									Upload audio
								</label>
								
							</div>
							{(b.soundTrack) && (<SoundPlayer style={{marginRight:"10px"}} soundFile={"http://ehla-media-bucket.s3.amazonaws.com/" + b.soundTrack}/>)}
							{(!b.soundTrack) && (<div style={{width:"35px"}}></div>)}
							<div style={{position:"relative", width:"100%", margin:"0 10px"}}>
								{(b.softDeleted) && (<div className={s.overlay}></div>)}
								<input className={s.srtWord} type="text" value={b.msg} onChange={(e)=>{
									bMsgDetail[indexB].msg = e.target.value;
									setBMsgDetail([...bMsgDetail]);
								}}/>
								<div>{b.msgJson.hk}</div>
							</div>
							<div style={{margin:"0 5px 0 auto"}} >
								<RedButton isEnabled={true} clickedAction={()=>{
									if (b.softDeleted) {
										delete bMsgDetail[indexB].softDeleted;
									} else {
										bMsgDetail[indexB].softDeleted = true;
									}
									setBMsgDetail([...bMsgDetail]);
								}} bText={"delete"} />
							</div>
						</div>
					</div>))
				}
				
				<div className={s.addWordHolder} >
					<img className={s.srtIcon} src={addCirclePng}  onClick={()=>{
						setBMsgDetail([...bMsgDetail, {type:"b",msg:"", msgJson:{hk:""}, soundTrack:null}]);
					}} />
				</div>
				
				
			</div>
			</div>)

		
		}
		
		
	</div>);
	
}

